<template>

    <div class="login-section">

        <div class="login-wrapper">

            <div class="bg" style="background-image: url('img/login/background-image.png')"></div>

            <div class="website-logo text-center">
                <img class="logo-big" src="img/login/logo-2.png" alt="">
                <img class="logo-small" src="img/login/logo.png" alt="">
            </div>

            <div class="login-content-wrapper">

                <div class="login-content">

                <form class="m-0 p-0" method="post">
                    <div class="form-group row">
                        <label class="col-form-label">{{ $t('LOGIN.INPUT_EMAIL')}}</label>
                        <input class="form-control inputTransparent" v-model="uniqueIdentifier" type="text" name="email"
                               required="">
                    </div>

                    <div class="form-group row">
                        <label class="col-form-label">{{ $t('LOGIN.INPUT_PASSWORD')}}</label>
                        <input class="form-control inputTransparent" v-model="password" type="password" name="password" autocomplete="off"
                               required="">
                    </div>                    
                </form>


                    <div class="row mt-4 mb-4">
                        <div class="col-6 text-left">
                            <router-link :to="{ name: 'Forgot' }" tag="a">
                                {{ $t('LOGIN.CANNOT_LOGIN') }}
                            </router-link>
                        </div>
                        <div class="col-6 text-right">
                            <button v-on:click="login" class="btn btn-fill btn-block btn-primary">
                                {{ $t('LOGIN.SUBMIT')}}
                            </button>
                        </div>
                    </div>


                    <router-link :to="{ name: 'Signup' }">
                        {{ $t('LOGIN.NO_ACCOUNT_LINK')}}
                    </router-link>

                    <LocaleLogin></LocaleLogin>

                </div>


            </div>


        </div>

    </div>

</template>
<script>
    import LocaleLogin from '@/components/Layout/LocaleLogin'

    export default {
        props: ['redirect'],
        components: {
            LocaleLogin
        },
        data() {
            return {
                errorMessage: ''
                , uniqueIdentifier: ''
                , email: ''
                , password: ''
                , passwordFieldType: 'password'
            }
        },
        methods: {
            login: function () {
                localStorage.setItem("uui", this.uniqueIdentifier);
                this.loading = true;
                let self = this;
                if (this.uniqueIdentifier !== "") {
                    this.$http.post(process.env.VUE_APP_BACKEND + `/auth/login`, {
                        email: this.uniqueIdentifier,
                        password: this.password
                    }).then(function () {
                        self.$router.push(self.loginUrl);
                    }).catch(function() {
                        self.$noty.error(self.$t("LOGIN.ERROR.CANNOT_LOGIN"));
                    });
                } else {
                    self.$noty.error(self.$t("LOGIN.ERROR.EMPTY_EMAIL"));
                }
            }
        },
        computed: {
            loginUrl: function() {
                if(this.redirect == undefined)
                {
                    return "/dashboard";
                }else{
                    if(this.redirect != "" && this.redirect != "/")
                    {
                        return this.redirect;
                    }else{
                        return "/dashboard";
                    }
                }
            }
        },
        mounted() {            
            if (localStorage.getItem("uui") !== null) {
                this.uniqueIdentifier = localStorage.getItem("uui");
            }
        }
    }
</script>
<style>
</style>
